import { render, staticRenderFns } from "./barGroupedByValues.vue?vue&type=template&id=a8ec675c"
import script from "./barGroupedByValues.vue?vue&type=script&lang=ts"
export * from "./barGroupedByValues.vue?vue&type=script&lang=ts"
import style0 from "./barGroupedByValues.vue?vue&type=style&index=0&id=a8ec675c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
